/**
 * Flattens a sectioned menu config into the flat list AntD renders.
 *
 * Menu configs are authored as sections (`RowActionConfig`,
 * `PlanActionMenuSections`) instead of a flat list holding
 * `{ type: 'divider' }` entries, so a divider is never a thing a caller can
 * misplace, double up, or strand by filtering the item next to it. Dividers
 * exist only here, derived from the boundaries between non-empty sections.
 */

type Divider = { type: 'divider' };

const DIVIDER: Divider = { type: 'divider' };

/**
 * Joins sections with a divider between each pair. Empty sections are skipped
 * entirely, which is what keeps a fully hidden group from leaving a rule behind,
 * and means the result never opens or closes on a divider.
 */
export function flattenMenuSections<T>(sections: readonly T[][]): (T | Divider)[] {
    const flat: (T | Divider)[] = [];

    for (const section of sections) {
        if (section.length === 0) continue;
        if (flat.length > 0) flat.push(DIVIDER);
        flat.push(...section);
    }

    return flat;
}
